
export default {
  context: (state) => {
    return state.context;
  },

  user: (state) => {
    return state.user;
  },

  page: (state) => {
    return state.page;
  },

  cart: (state) => {
    return state.cart;
  },

  sidebar: (state) => {
    return state.sidebar;
  },

  infiniteLoading: (state) => {
    return state.infiniteLoading;
  },
};



// WEBPACK FOOTER //
// ./src/js/store/getters.js